import { Box, Link, Typography } from "@mui/material";
import { InfoDisclaimerBox } from "@covertree/ui/content";

import { SALES_EMAIL_ADDRESS } from "@covertree/consts";

import { CardItem } from "./CardItem";
import { MortgageBillItem } from "./MortgageBill/MortgageBillItem";
import { usePaymentMethods } from "./usePaymentMethods";

interface Props {
  readonly policyLocator: string;
}

/** Read-only payment method for the endorsement checkout — the default method is resolved automatically. */
export function PaymentMethods({ policyLocator }: Props) {
  const { billingInterest, defaultCard, defaultAch, isDefaultCardExpired } =
    usePaymentMethods();
  const defaultMethod = defaultCard || defaultAch;

  return (
    <Box mt={3}>
      <Typography variant="h6" gutterBottom>
        Payment method
      </Typography>

      {billingInterest && (
        <MortgageBillItem
          additionalInterest={billingInterest}
          policyLocator={policyLocator}
        />
      )}

      {!billingInterest && defaultMethod && (
        <CardItem
          method={defaultMethod}
          policyLocator={policyLocator}
          isExpired={isDefaultCardExpired}
        />
      )}

      {!billingInterest && !defaultMethod && (
        <InfoDisclaimerBox mt={3}>
          No default payment method is available for this policy. Please contact{" "}
          <Link color="secondary" href={`mailto:${SALES_EMAIL_ADDRESS}`}>
            {SALES_EMAIL_ADDRESS}
          </Link>{" "}
          for assistance.
        </InfoDisclaimerBox>
      )}
    </Box>
  );
}
